import { useLocalStorage } from '@ai-tutor/ui';
import { useFocusTimer } from '@/contexts/FocusTimerContext';
import { useNow } from '@/hooks/ui/useNow';
import { toMinutes } from '@/lib/focus/format';
import { toViewModel } from '../focus/focusViewModel';
import { useWellbeingKeys } from '../wellbeingStorage';
import type { Worry } from '../worry/WorryDump';
import { BreatheTile, FocusTile, WorryTile } from './HubTiles';

function LiveFocusTile() {
  const { state, today } = useFocusTimer();
  const now = useNow(state.phase === 'focus' || state.phase === 'break');
  const view = toViewModel(state, now);
  return (
    <FocusTile
      phase={state.phase}
      timeLabel={view.timeLabel}
      progress={view.progress}
      intention={view.intention}
      todayMinutes={toMinutes(today.focusMs)}
      todayBlocks={today.blocks}
    />
  );
}

function LiveWorryTile() {
  const keys = useWellbeingKeys();
  const [worries] = useLocalStorage<Worry[]>(keys.worries, []);
  return <WorryTile count={worries.length} />;
}

/**
 * The hub's three tools: three across on desktop; on tablets Focus, the
 * lead tool, takes the first row and the other two share the second, so
 * no tile sits alone beside a hole; stacked on phones.
 */
export function ToolCards() {
  return (
    <div className='grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3'>
      <LiveFocusTile />
      <BreatheTile />
      <LiveWorryTile />
    </div>
  );
}
